module.exports = __webpack_public_path__ + "static/media/towTruckReciept.97d247ab.svg";